/**
 * 06-24-2019
 * The best app ever.
 * Check for instance using $( el ).data( 'uiWeb1Request' );
 * ~~ Scott Johnson
 */

/** List jshint ignore directives here. **/
/* jshint undef: true, unused: true */
/* jshint browser:true */
/* global require: false */

// // Create reusable request.
// web1_request.pool({
//    expire_ms: 5000,
//    wr: 'ReadAudioFile',
//    method: 'get'
// });// /read()


/**
 * 09-04-2014
 * This class helps communicate results and errors after web1 json ajax
 * requests.
 * @param {object} o_options - An object determining the options for this reusable request.
 * @returns {object}
 * 
 * Available options:
 * @property {number} [client_id] - The client id this request is bound to.
 * @property {string} [data_type] - The type of response data expected from in the response.
 * @property {string} [sidtoken] - The session ID token to send with the request.
 * @property {string} method - The type of request to send. eg: "get" or "post".
 * @property {string} wr - The web1 method to request. eg: "get_session.wr" becomes "get_session"
 *
 * //[ Begin Example

   var web1 = web1_request({ wr:'ScheduleUpdate', data:oData, callback:fnCallback });
   web1.send();

   * // End Example ]

   * //[ Begin Example

   var web1 = web1_request({ wr:'ScheduleUpdate' });
   web1.send({ data:oData, callback:fnCallback });

   * // End Example ]

   * //[ Begin Example

   // Using promises and the the javascript "spread" operator.
   var c_name = 'ScheduleUpdate';
   var web1 = web1_request({ wr:'ScheduleUpdate', data:o_data });
   web1.send()
   .then(function ([o_error, o_result]) {

      // Check for to see if the request was completed and that a
      // valid JSON response was received.
      if (o_error) {
         // An error happend that either failed to recognize the
         // response or we never reached the server at all.
         alert( c_name.concat( ' Failure: ', o_error.message ) );
         return;
      }// /if()


      // The server received our request and provided us with a valid JSON
      // response. Now we check if the web1 server's response contains an error 
      // message.
      if (o_result.error) {
         // The server sent us an error message. Display the message to the user.
         alert( c_name.concat( ' Error: ', o_result.error.message ) );
         return;
      }

      // At this point the server has provided us with the data we asked for.
      alert( c_name.concat( 'Success!' ) );
   })
   .catch(function (oError) {
      // This can happend when web1 randomly returns a "no output" html error.
      alert( c_name.concat(' Failed: ', oError.message ) );
   });

   * // End Example ]


 */

   import web1_result from './web1-result';
   // const web1_result = require( './web1-result' );
   const deep_extend = require( 'deepmerge' );
   const axios = require( 'axios' );

   const web1_request = function( o_options ){
      var c_id = [generate_random_string( 5 ),generate_random_string( 7 ),generate_random_string( 5 )].join( '-' );

      var self = {
         id: c_id,
         /**
          * This object holds the default request options.
          */
         options: null,

         _cache: {},

         _cache_expire: null,

         /**
          * This method executes the ajax request and processes the response.
          * @returns {promise}
          */
         send: function( o_options/* , undefined */ ) {
            var o_request, o_settings = Object.assign( {}, self.options, o_options );

            o_request = web1_request._prepareRequest.call( self, o_settings );

            self._send_request( o_request );

            // Return to the callee the promise object in the result object.
            return o_request.response.promise;
            
         },// /send()

         _send_request: function( o_request ){
            var elapsed_ms;
            var o_pool = web1_request.get_pool( o_request.settings );
            var c_queue_path = web1_request.get_pool_path( o_request.settings );            
            var o_queue = o_pool.get_queue( c_queue_path );

            o_queue.requests.push( o_request );

            if( o_queue.status == 'sending' ){
               return;
            }

            // Determines the status of the current queue. eg: `idle` or `sending`
            o_queue.status = 'sending';

            // Determines the amount of milliseconds since the last result of the current queue.
            elapsed_ms = o_queue.result ?new Date() - o_queue.result.time_stamp :1;
            
            if( !o_queue.result || elapsed_ms > o_pool.expire_ms ){
               // Cached result expired.
               o_queue.result = null;

               // Send our request now.
               return self.send_now( o_request );
            }


            // We have valid cached data.
            o_request.response.reply( 'result', o_queue.result.data );
            
         },// /_send_request()


         send_now: function( o_request ){

            // var self = this;
            if( typeof web1_request._mocked_requests[ o_request.settings.wr ] == 'function' ){
               web1_request._mock_request( o_request );
               return;
            }

            const axios_settings = {
               url: o_request.settings.url,
               method: o_request.settings.method,
               responseType: o_request.settings.data_type
            };
            
            switch( o_request.settings.method ){
            case 'get':
               axios_settings.params = o_request.settings.data;
               break;

            case 'post':
            default:
               Object.assign( axios_settings, {
                  data: serialize( o_request.settings.data ),
                  headers: {
                     'Content-Type': 'application/x-www-form-urlencoded'
                  }
               });
            }// /switch()

            axios( axios_settings )
            .then(function( result ){
               var o_pool = web1_request.get_pool( o_request.settings );
               var c_queue_path = web1_request.get_pool_path( o_request.settings );
               var o_queue = o_pool.get_queue( c_queue_path );
               var o_req;

               // Determines the status of the current queue. eg: `idle` or `sending`
               o_queue.status = 'idle';

               // Cache the result of this request into the current queue.
               o_queue.result = {
                  time_stamp: new Date(),
                  data: result
               };

               // Determines one queued request.
               o_req = o_queue.requests.shift();

               /** 
                * Loop over each queued request and reply with the result of 
                * this request.
                */
               while( o_req ){
                  // console.log( 'c_queue_path', c_queue_path );
                  o_req.response.reply( 'result', result.data );
                  o_req = o_queue.requests.shift();
               }
                  // console.log( ' ' );

               if( o_pool.expire_ms === 0 ){
                  // This is a volatile pool which must be destroyed immediately.
                  o_pool.destroy();
               }

            })
            .catch(function( /* oXhr, cStatus, cError */ ){
               o_request.response.reply( 'error', Array.prototype.slice.call( arguments ) );
            });
            
         },// /send_now()

      };// /web1_request{}

      self.options = Object.assign( {
         client_id: web1_request._client_id,
         data_type: 'json',
         sidtoken: null,
         method: 'get',
         wr: null,
      }, o_options );

      web1_request._instance[ c_id ] = self;

      return self;

   };// /web1_request()





   // { getReadAudioFile: { expire_ms:0, result:null, queue:[] } }
   web1_request._pools = {};
   web1_request._instance = {};
   web1_request._apirid = 0;


   // This method returns a new unique apirid for this application scope.
   web1_request.apirid = function() {
      web1_request._apirid++;
      return ''.concat( new Date().getTime(),'-',web1_request._apirid );
   };// /apirid()


   /**
    * This method executes the ajax request and processes the response.
    */
   web1_request._prepareRequest = function( o_settings/* , undefined */ ) {
      var oResult, oSettings;

      /**
       * Override any static options with the instance options provided in the
       * o_settings parameter.
       */
      oSettings = { 
         client_id: web1_request._client_id,
         data:{} 
      };
      oSettings = deep_extend( oSettings, this.options );
      oSettings = deep_extend( oSettings, o_settings );

      // params: cName, fnCallback, oContext
      oResult = web1_result( ( oSettings.name || oSettings.wr ), oSettings.context );

      if ( oSettings.client_id ) {
         oSettings.url = '/'.concat( oSettings.client_id, '/', oSettings.wr, '.wr' );
      }
      else {
         oSettings.url = '/'.concat( oSettings.wr, '.wr' );
      }

      // Sort the data object by the keys.
      oSettings.data = sort_object( oSettings.data );

      oSettings.data.apirid = web1_request.apirid();

      if( oSettings.sidtoken ){
         oSettings.data.sidtoken = oSettings.sidtoken;
      }
      
      oSettings.success = oResult.success;
      oSettings.error = oResult.error;

      return { settings:oSettings, response:oResult };
   };// /_prepareRequest()

   /** 
    * Determines the client ID for all requests within the scope of the 
    * application.
    */
   web1_request._client_id = null;

   /** 
    * Sets the client ID for all requests within the scope of the application.
    */
   web1_request.set_client_id = function( n_client_id, undefined ){
      var i;

      if ( n_client_id === undefined ) {
         return web1_request._client_id;
      }

      web1_request._client_id = n_client_id;

      /**
       * Loop over each instance and update it's client_id.
       */
      for( i in web1_request._instance ) {
         web1_request._instance[i].options.client_id = n_client_id;
      }// /for()

   };// /set_client_id()

   /** 
    * This method determines a pool path based on the properties provided.
    * @param {object} o_options - An object of properties defining the path.
    * 
    * Available properties:
    * @property {string} method - The type of request. eg: "get" or "post".
    * @property {string} wr - The name of the web1 method to call.
    * @property {object} [data] - The parameters being sent with the request.
    * 
    * @return {string} eg: "get/get_session/{}"
    * 
    */
   web1_request.get_pool_path = function( o_options ){
      var a_pool_path = [];
      var o_settings = {
         method: o_options.method,
         wr: o_options.wr,
         data: deep_extend( {}, o_options.data )
      };

      if( o_settings.method ){
         a_pool_path.push( o_settings.method.toLowerCase() );
      }

      if( o_settings.wr ){
         a_pool_path.push( o_settings.wr.toLowerCase() );
      }

      if( o_settings.data ){
         delete o_settings.data.apirid;
         a_pool_path.push( JSON.stringify( o_settings.data ).toLowerCase() );
      }

      return a_pool_path.join( '/' );
   };// /get_pool_path()


   /** 
    * 
    * This method tries to find an existing based on the properties provided. If
    * a pool is not found, a new pool is created then returned.
    * @param {object} o_options - An object of properties defining the path.
    * 
    * Available properties:
    * @property {string} method - The type of request. eg: "get" or "post".
    * @property {string} wr - The name of the web1 method to call.
    * @property {object} [data] - The parameters being sent with the request.
    * 
    * @return {object}
    * 
    */
   web1_request.get_pool = function( o_options ){

      // Determines the path to the pool. eg: 'get/get_session/{params:more,than:needed}'
      var c_pool_path = web1_request.get_pool_path( o_options );

      // Determines ["get", "get_session"]
      /* var a_pool_path; */

      // Determines the pool that was found. 
      var o_pool = null;

      // Check for a pool.
      o_pool = web1_request._pools[ c_pool_path ];

      if( o_pool ){
         // Found a pool.
         return o_pool;
      }



      // Determines the pool path with empty params. eg: 'get/get_session/{}'
      c_pool_path = c_pool_path.split( '/', 2 ).join( '/' ).concat( '/{}' );

      // Check for a pool.
      o_pool = web1_request._pools[ c_pool_path ];

      if( o_pool ){
         // Found a pool.
         return o_pool;
      }


      // No pool found. Create a volatile one.
      o_pool = web1_request.pool({
         expire_ms: 0,
         path: c_pool_path,
         data: o_options.data,
         method: o_options.method,
         wr: o_options.wr.toLowerCase()
      });


      return o_pool;
   };// /get_pool()


   /** 
    * This method defines a new pool. If `expire_ms` equals `0` then the pool is
    * considered volatile and is destroyed immediately after reply.
    */
   web1_request.pool = function( o_options ){
      var c_pool_path = web1_request.get_pool_path( o_options );

      var self = Object.assign( {
         path: null,
         wr: null,
         method: null,
         data: null,
         expire_ms: 0,
         queues: {}
      }, 
      {
         path: c_pool_path,
         data: o_options.data,
         method: o_options.method,
         wr: o_options.wr.toLowerCase(),
         expire_ms: o_options.expire_ms,
         queues: {}
      });

      /** 
       * This method tries to find an existing queue within the current pool. If
       * a queue is not found, a new queue is created then returned.
       */
      self.get_queue = function( c_queue_path ){

         // Check for an already existing queue.
         if( !self.queues[ c_queue_path ] ){
            // This pool doesn't have a queue yet for this path. Create one.
            self.queues[ c_queue_path ] = web1_request.generate_queue( c_queue_path );
         }
         
         return self.queues[ c_queue_path ];
      };// /get_queue()


      /** 
       * This method destroys the current pool. The purpose of this method is
       * to schedule the pool object and all of it's children to be collected
       * by garbage and free up memory.
       */
      self.destroy = function(){
         var c_path;

         for( c_path in self.queues ){
            self.queues[ c_path ].destroy();
         }

         self.data = null;
         self.queues = null;
         delete web1_request._pools[ self.path ];
      };// /destroy()

      web1_request._pools[ c_pool_path ] = self;

      return self;
      
   };// /pool()

   web1_request.generate_queue = function( c_queue_path ){
      var self = {
         path: c_queue_path,
         requests: [],
         status: 'idle',
         result: null
      };



      /** 
       * This method destroys the current queue. The purpose of this method is
       * to schedule the queues object and all of it's children to be collected
       * by garbage and free up memory.
       */
      self.destroy = function(){
         self.requests = null;
         self.result = null;
      };// /destroy()

      return self;
   };// /generate_queue()


   // Determines a list of mocked requests by "wr" name.
   web1_request._mocked_requests = {};

   /** 
    * Creates a new mocked request for testing.
    */
   web1_request.mock = function( c_wr, fn_callback ){
      web1_request._mocked_requests[ c_wr ] = fn_callback;
   };// /mock()

   /** 
    * Executes a mocked request callback.
    */
   web1_request._mock_request = function( o_request ){
      var o_pool = web1_request.get_pool( o_request.settings );
      var c_queue_path = web1_request.get_pool_path( o_request.settings );
      var o_queue = o_pool.get_queue( c_queue_path );
      
      // Determines the status of the current queue. eg: `idle` or `sending`
      o_queue.status = 'idle';
      
      web1_request._mocked_requests[ o_request.settings.wr ]( o_request );
   };// /_mock_request()

   /**
    * This function outputs a random string 'n_length' characters long.
    */
   var generate_random_string = (function( c_charlist ){

      var n_list_length = c_charlist.length;
      return function ( n_length ) {

         if ( !n_length ) {
            n_length = Math.floor( Math.random() * n_list_length );
         }

         var str = '';
         for (var i = 0; i < n_length; i++) {
            str += c_charlist[ Math.floor( Math.random() * n_list_length ) ];
         }
         return str;
      };

   }( '0123456789abcdef' ));


   // // Mimics closer to PHP's explode function. Not the same as String.split();
   // var explode = function( c_delim, c_string, n_limit, undefined ){
   //    var a_parts = c_string.split( c_delim );
   //    var n_l, a_leftover = [];

   //    if( n_limit != undefined ){
   //       n_l = ( n_limit || 1 ) - 1;
   //       a_leftover = a_parts.slice( n_l );
   //       a_parts = a_parts.slice( 0, n_l );
   //       a_parts.push( a_leftover.join( c_delim ) );
   //    }

   //    return a_parts;
   // };// /explode()


   /** 
    * This function sorts an object by it's keys.
    */
   var sort_object = function( o_object ){
      var o_sorted = {};
      Object.keys(o_object).sort().forEach(function(key) {
         o_sorted[key] = o_object[key];
      });

      return o_sorted;
   };// /sort_object()

   




// var log_filter = function( o_queue ){
//    var args = [].slice.call(arguments, 1 );



//    if( o_queue.path.indexOf( 'getaudiolibrary' ) > -1 ){
//       console.log.apply( console, args );
//    }

// };// /log_filter()

const serialize = function( o_obj ){
   var p;
   const a_params = [];

   for( p in o_obj ){
      a_params.push( `${p}=${encodeURIComponent( o_obj[p] )}` );
   }// /for()

   return a_params.join( '&' );

};// /serialize()

//module.exports = web1_request;
export default web1_request;